import { createReducer } from '@reduxjs/toolkit'
import { forEach } from 'lodash'
import ActionTypes from '@constants/action_types.js'
import { arrayToKeyedObject } from '@utils/object.js'

export const initialState = {}

function getDefaultAttributes() {
  return {}
}

export const membership = createReducer(initialState, builder => {
  builder.addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => receiveEntities(state, action))
})

function receiveEntities(state, action) {
  const { payload } = action
  if (payload.hasOwnProperty('memberships')) {
    let { memberships } = payload
    if (Array.isArray(memberships)) {
      memberships = arrayToKeyedObject(memberships, 'id')
    }
    const keys = Object.keys(memberships)
    forEach(keys, key => {
      const membership = memberships[key]
      const idString = membership.id.toString()
      const existing = state[idString]
      state[idString] = {
        ...getDefaultAttributes(),
        ...existing,
        ...membership,
      }
    })
  }
  return state
}

export default membership
